import { PixelRatio } from 'react-native';
const pixelDensity = PixelRatio.get();
export const imageDensity = pixelDensity >= 3 ? '3x' : pixelDensity >= 2 ? '2x' : '1x';
const imageDensitySuffix = imageDensity === '1x' ? '' : `@${imageDensity}`;
// (\.(png|jpe?g))?$  - Optionally matches a dot followed by 'png', 'jpg', or 'jpeg' at the end of the string.
const reImageExtension = /(\.(png|jpe?g))?$/i;
export function addDensityToSrc(src) {
    return src.replace(reImageExtension, (_match, extension) => {
        if (extension) {
            return `${imageDensitySuffix}${extension}`;
        }
        // If there's no extension, append '@2x' at the end.
        return imageDensitySuffix;
    });
}
const reNetworkSuffix = /(_BASE|_ERC20|_POLYGON|_SPL)$/i;
export function getImageFileNameCodeFromCurrencyCode(currencyCode) {
    // AGRO_6MBND10JAN25...
    if (currencyCode.startsWith('AGRO_'))
        return 'agro';
    // BRMD_15MBND...
    if (currencyCode.startsWith('BRMD_'))
        return 'ber';
    // Funds
    if (currencyCode.includes('DH-BTC'))
        return 'dhbtc';
    if (currencyCode.includes('DH-ETH'))
        return 'dheth';
    if (currencyCode.includes('-TREND'))
        return 'trend';
    if (currencyCode.includes('XCOF-'))
        return 'xcof';
    // Cryptos
    if (currencyCode === 'POL_ERC20')
        return 'matic';
    if (currencyCode === 'USDC_POLYGON_NXTB')
        return 'usdc';
    // BTC, ETH, LINK_ERC20, SOY_SPL...
    return currencyCode.replace(reNetworkSuffix, '').toLowerCase();
}
